import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { EnFlagVariant } from '../../locales/languageConfig';

export const localeSlice = createSlice({
  name: 'locale',
  initialState: {
    userLocaleKey: null as string | null,
    enFlagVariant: null as EnFlagVariant | null,
  },
  reducers: {
    setUserLocaleKey: (state, action: PayloadAction<string>) => {
      state.userLocaleKey = action.payload;
    },
    setEnFlagVariant: (state, action: PayloadAction<EnFlagVariant>) => {
      state.enFlagVariant = action.payload;
    },
  },
});

export const { setUserLocaleKey, setEnFlagVariant } = localeSlice.actions;

export const selectEnFlagVariant = (state: any): EnFlagVariant | null => state.locale.enFlagVariant;

export default localeSlice.reducer;
